import styles from '@lmt/unicorn-shared/app/components/calendar/visit/components/FreeTimeSlotSearchControl.module.scss';
import { RadioButton } from '@lmt/unicorn-shared/app/components/common/ui-kit/RadioButton';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import OptionIcon from '@lmt/unicorn-shared/app/icons/option.svg?react';
import { IconButton, Menu } from '@mui/material';
import React, { FC, useState } from 'react';

type Props = {
  isParticularTime: boolean;
  setIsParticularTime: (value: boolean) => void;
};

export const TimeSlotSearchOptions: FC<Props> = (props) => {
  const i18n = useScopedTranslation('event.visit');
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <IconButton
        disableFocusRipple={true}
        disableTouchRipple={true}
        disableRipple={true}
        className={styles.optionButton}
        aria-label="more"
        aria-controls="option-menu"
        aria-haspopup="true"
        onClick={(event: any) => setAnchorEl(event.currentTarget)}
      >
        <OptionIcon
          className={styles.optionButtonIcon}
          data-test-id={'time-slot-search-options'}
        />
      </IconButton>
      <Menu
        id="option-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <>
          <RadioButton
            name={'any-time-radio-button'}
            className={styles.searchOption}
            title={i18n.t('search_free_slot_any_time')}
            checked={!props.isParticularTime}
            onClick={() => props.setIsParticularTime(false)}
          />
          <RadioButton
            name={'particular-time-radio-button'}
            className={styles.searchOption}
            title={i18n.t('search_free_slot_particular_time')}
            checked={props.isParticularTime}
            onClick={() => props.setIsParticularTime(true)}
          />
        </>
      </Menu>
    </>
  );
};
